module.exports = __webpack_public_path__ + "img/MP4.3c890c7e.png";